import React from 'react';
import { Box, Button } from '@mui/material';

function HorasButtons({ recurso, classes, handleData }) {
  const qtdDiario = Number(recurso?.qtdDiario) || 0;
  return (
    <Box sx={{ marginLeft: '2%', justifyContent: 'flex-end' }}>
      {qtdDiario <= 0 ? null : (
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtdDiario - 1);
          }}
          className={classes.buttons}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          -
        </Button>
      )}
      {qtdDiario >= 24 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtdDiario + 1);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +
        </Button>
      )}
      {qtdDiario > 20 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +4h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtdDiario + 4);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +4h
        </Button>
      )}
      {qtdDiario > 16 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +8h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtdDiario + 8);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +8h
        </Button>
      )}
    </Box>
  );
}

export default HorasButtons;
